// extracted by mini-css-extract-plugin
export default {"label":"search-input_label__B9Fjb","input":"search-input_input__nABLW","labelTop":"search-input_labelTop__iouyr","inputPrefix":"search-input_inputPrefix__Y1dWb"};